export const NEW = 'Non-Existing'
export const EXISTING = 'Existing'

export default {
  NEW,
  EXISTING,
}
